<template>
  <section
    class="-m-1 w-[280px] overflow-hidden"
    data-test="message-reactions-flyout"
  >
    <ul class="flex max-h-[320px] flex-col gap-[14px] overflow-y-auto px-4 py-[11px]">
      <li
        v-for="item in items"
        :key="`${item.author}-${item.emoji}`"
      >
        <message-reaction-flyout-item
          :author="item.author"
          :emoji="item.emoji"
        />
      </li>
    </ul>
  </section>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { computed } from 'vue'

import { useReactionsStore } from '@/entities/reaction'

import MessageReactionFlyoutItem from './message-reaction-flyout-item.vue'

const props = defineProps<{
  eventId: number
}>()

const reactionsStore = useReactionsStore()
const { reactionEvents } = storeToRefs(reactionsStore)
const { getReactionListItems } = reactionsStore

const items = computed(() => {
  void reactionEvents.value.get(props.eventId)
  return getReactionListItems(props.eventId)
})
</script>
